import Heading, {
  HeadingTag,
} from "immigram-ui-cmon/src/components/Heading/Heading";
import React from "react";

import {
  ConfigParamValueWithModifiers,
  ImmigramFormElementConfigBase,
  ImmigramFormElementType,
  useModifiedConfigParamValue,
} from "./common";

export interface ImmigramFormElementConfigHeading
  extends ImmigramFormElementConfigBase {
  type: ImmigramFormElementType.Heading;
  tag: HeadingTag;
  content: ConfigParamValueWithModifiers;
}

interface ImmigramFormHeadingProps {
  elementConfig: ImmigramFormElementConfigHeading;
}

function ImmigramFormHeading({ elementConfig }: ImmigramFormHeadingProps) {
  const content = useModifiedConfigParamValue(elementConfig.content);

  return (
    <Heading tag={elementConfig.tag} className="my-0">
      {content}
    </Heading>
  );
}

export { ImmigramFormHeading };
